import Header from "../../components/feature/Header";

export default function Blog() {
  return (
    <div className="w-full min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <iframe
          width="100%"
          height="100%"
          src="https://blog.moveideias.com/blog/"
          title="Blog Moveideias"
          frameBorder="0"
          className="w-full h-full min-h-[calc(100vh-64px)]"
        />
      </div>
    </div>
  );
}
